<template>
    <div class="EvieMobileToolbar">
        <NewButton
            v-if="hasConversations"
            class="EvieMobileToolbar__toggle"
            variant="flat"
            color="neutral"
            size="icon-xs"
            title="Open sidebar (⌘.)"
            aria-label="Open sidebar"
            @click="$emit('toggle')"
        >
            <EidIcon :icon-src="faSidebar" />
        </NewButton>
        <div v-if="!isSidebarOpen" class="EvieMobileToolbar__center">
            <span class="EvieMobileToolbar__title">{{ conversationTitle }}</span>
            <NewButton
                v-if="conversationTitle"
                class="EvieMobileToolbar__editBtn"
                variant="flat"
                color="neutral"
                size="icon-xs"
                aria-label="Rename conversation"
                @click="$emit('rename')"
            >
                <EidIcon :icon-src="faPen" />
            </NewButton>
        </div>
    </div>
</template>

<style lang="scss">
.EvieMobileToolbar {
    display: none;

    @media (max-width: 1024px) {
        display: flex;
        align-items: center;
        width: 100%;
        height: 48px;
        padding: 0 8px;
        border-bottom: 1px solid var(--eidSecureBlue-10);
        background: var(--eidWhite);
        flex-shrink: 0;
        position: relative;
    }

    &__center {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        min-width: 0;
        padding: 0 8px;
    }

    &__title {
        font-family: var(--evie-font-stack);
        font-size: 14px;
        font-weight: 600;
        color: var(--eidSecureBlue);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>

<script lang="ts">
    import { defineComponent } from 'vue';

    import { faSidebar, faPen } from '@fortawesome/pro-light-svg-icons';

    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';

    import NewButton from '@/components/new-button/NewButton.vue';

    export default defineComponent({
        name: 'EvieMobileToolbar',
        components: { EidIcon, NewButton },
        props: {
            hasConversations: { type: Boolean, default: false },
            isSidebarOpen: { type: Boolean, default: false },
            conversationTitle: { type: String, default: '' },
        },
        emits: [ 'rename', 'toggle' ],
        data() {
            return { faSidebar, faPen };
        },
    });
</script>
